import { useChain } from './useChain';

const useChainId = () => {
  const chain = useChain();

  return chain.id;
};

export default useChainId;
